import { PdpCatalogFulfillmentType, useCatalogProductIdParams, usePdpBaseInfo } from '@domains/pdp-common';

export const useBadgeService = () => {
  const params = useCatalogProductIdParams();
  const { product } = usePdpBaseInfo(params);

  const country = 'KR';

  const isFastShipping = product.shipping_send_date?.fast_shipping?.is_fast_type && country === 'KR';
  const isZigzinProduct = checkZigzinProduct(product.fulfillment_type, country);

  const isHide = !product.badge?.above_atf_title_badge_list?.length && !isFastShipping && !isZigzinProduct;

  return {
    badgeList: product.badge?.above_atf_title_badge_list ?? [],
    isHide,
  };
};

function checkZigzinProduct(fulfillment_type: PdpCatalogFulfillmentType, country: string) {
  return Boolean(fulfillment_type === PdpCatalogFulfillmentType.ZIGZIN && country === 'KR');
}
